import ResetPwBtn from '@/components/resetPwBtn';
import gInput from '@/components/googlemaps/gInput';
import FormMixin from '@/mixins/formvalid';
export default {
  components: {
    'g-input': gInput,
    'm-reset-pw-btn': ResetPwBtn
  },
  mixins: [FormMixin],
  props: ['dialog', 'user', 'form'],
  data () {
    return {
      valid: false,
      adress_notValid: false,
      dateFormatted: null,
      items: [],
      active: null
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    close () {
      this.$emit('close');
    },
    reset () {
      this.$refs.form.reset();
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.form.address && this.form.zip && this.form.city) {
          this.$emit('save', this.form);
        } else {
          this.adress_notValid = true;
          console.log('check your address');
        }
      } else {
        console.log('form not valid');
      }
    },
    update () {
      if (this.$refs.form.validate()) {
        if (this.form.address && this.form.zip && this.form.city) {
          this.$emit('update', this.form);
        } else {
          this.adress_notValid = true;
          console.log('check your address');
        }
      } else {
        console.log('form not valid');
      }
    },
    setAddress (v) {
      this.form.fullAddress = v;
    },
    setPlace (v) {
      if (v.street_number && v.postal_code && v.route && v.locality) {
        this.form.address = v.route + ' ' + v.street_number;
        this.form.zip = v.postal_code;
        this.form.city = v.locality || '';
        this.form.latitude = v.latitude;
        this.form.longitude = v.longitude;
        this.adress_notValid = false;
      } else {
        this.adress_notValid = true;
        this.form.fullAddress = this.form.address = this.form.zip = this.form.city = null;
      }
      console.log(v);
    },
    prefill (d) {
      for (var key in d) {
        this.form[key] = d[key]; // copies each property to the form object
      }
      this.adress_notValid = false;
      this.active = this.user.active;
      console.log(d.fullAddress, this.$refs.address);
      this.$nextTick(() => { this.$refs.address.update(d.fullAddress); });
    }
  },
  watch: {
    dialog (value) {
      this.init(value);
    }
  }
}
